import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import CustomDateInput from 'components/common/CustomDateInput';

const InputDatePicker = ({ column, displayName, selected, handleChange }) => {
  const [tempDate, setTempDate] = useState('');

  // sync từ selected → input text
  useEffect(() => {
    if (!selected) {
      setTempDate('');
      return;
    }

    const date = typeof selected === 'string' ? new Date(selected) : selected;

    if (date instanceof Date && !isNaN(date)) {
      setTempDate(date.toLocaleDateString('en-GB'));
    }
  }, [selected]);

  const handleDateChange = e => {
    const value = e.target.value;

    if (value === '') {
      setTempDate('');
      handleChange(column, undefined);
      return;
    }

    setTempDate(value);

    const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
    if (!dateRegex.test(value)) return;

    const [day, month, year] = value.split('/').map(Number);

    const newDate = new Date(year, month - 1, day);

    // validate
    if (
      newDate.getFullYear() === year &&
      newDate.getMonth() === month - 1 &&
      newDate.getDate() === day
    ) {
      handleChange(column, newDate);
    }
  };

  return (
    <Form.Group controlId={column}>
      {displayName && <Form.Label>{displayName}</Form.Label>}

      <DatePicker
        selected={selected || null}
        openToDate={selected || new Date()}
        onChange={date => {
          handleChange(column, date);
          setTempDate(date ? date.toLocaleDateString('en-GB') : '');
        }}
        calendarStartDay={1}
        dateFormat="dd/MM/yyyy"
        customInput={
          <CustomDateInput
            formControlProps={{
              placeholder: 'dd/mm/yyyy',
              value: tempDate,
              onChange: handleDateChange,
              onKeyDown: e => {
                if (e.key === 'Enter') {
                  handleDateChange(e);
                }
              }
            }}
          />
        }
      />
    </Form.Group>
  );
};

InputDatePicker.propTypes = {
  column: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  selected: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  handleChange: PropTypes.func.isRequired
};

export default InputDatePicker;
